(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('[data-dropdown-menu]');
      this.disclosures.forEach((dropdown) => {
        dropdown.classList.remove('active');
        const button = dropdown.querySelector(':scope > button');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mega Menu Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const megaMenuItems = document.querySelectorAll('[data-mega-menu]');
    
    megaMenuItems.forEach(item => {
      const button = item.querySelector('button');
      const menu = item.querySelector('.mega-menu');
      let timeout;

      item.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        menu.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          menu.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
        }, 200);
      });

      // Keyboard navigation
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        menu.classList.toggle('active');
      });
    });

    // Close mega menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-mega-menu]')) {
        document.querySelectorAll('.mega-menu.active').forEach(menu => {
          menu.classList.remove('active');
          menu.closest('[data-mega-menu]').querySelector('button').setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Custom Dropdown Menu Functionality (Safari-compatible)
    const dropdownMenus = document.querySelectorAll('[data-dropdown-menu]');
    
    dropdownMenus.forEach(menu => {
      const button = menu.querySelector(':scope > button');
      const submenuWrapper = menu.querySelector('.header__submenu-wrapper');
      let timeout;

      // Hover functionality
      menu.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        closeAllDropdowns(menu);
        menu.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          menu.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
          // Close all nested dropdowns
          menu.querySelectorAll('[data-nested-dropdown].active').forEach(nested => {
            nested.classList.remove('active');
            nested.querySelector('button').setAttribute('aria-expanded', 'false');
          });
        }, 200);
      });

      // Click functionality for mobile/accessibility
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isActive = menu.classList.contains('active');
        
        closeAllDropdowns();
        
        if (!isActive) {
          menu.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      });

      // Handle nested dropdowns
      const nestedDropdowns = menu.querySelectorAll('[data-nested-dropdown]');
      nestedDropdowns.forEach(nested => {
        const nestedButton = nested.querySelector(':scope > button');
        
        nested.addEventListener('mouseenter', () => {
          // Close other nested dropdowns at same level
          const parent = nested.closest('.header__submenu');
          if (parent) {
            parent.querySelectorAll(':scope > li > [data-nested-dropdown].active').forEach(other => {
              if (other !== nested) {
                other.classList.remove('active');
                other.querySelector('button').setAttribute('aria-expanded', 'false');
              }
            });
          }
          
          nested.classList.add('active');
          nestedButton.setAttribute('aria-expanded', 'true');
        });

        nested.addEventListener('mouseleave', () => {
          setTimeout(() => {
            nested.classList.remove('active');
            nestedButton.setAttribute('aria-expanded', 'false');
          }, 200);
        });

        nestedButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isActive = nested.classList.contains('active');
          
          // Close other nested dropdowns
          const parent = nested.closest('.header__submenu');
          if (parent) {
            parent.querySelectorAll(':scope > li > [data-nested-dropdown].active').forEach(other => {
              if (other !== nested) {
                other.classList.remove('active');
                other.querySelector('button').setAttribute('aria-expanded', 'false');
              }
            });
          }
          
          nested.classList.toggle('active');
          nestedButton.setAttribute('aria-expanded', !isActive);
        });
      });
    });

    // Close all dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-dropdown-menu]')) {
        closeAllDropdowns();
      }
    });

    function closeAllDropdowns(except = null) {
      document.querySelectorAll('[data-dropdown-menu]').forEach(menu => {
        if (menu !== except) {
          menu.classList.remove('active');
          const button = menu.querySelector(':scope > button');
          if (button) {
            button.setAttribute('aria-expanded', 'false');
          }
          // Close nested dropdowns
          menu.querySelectorAll('[data-nested-dropdown].active').forEach(nested => {
            nested.classList.remove('active');
            nested.querySelector('button').setAttribute('aria-expanded', 'false');
          });
        }
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAllDropdowns();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
